import { render } from "./GalleryView.vue?vue&type=template&id=60b20898"
import script from "./GalleryView.vue?vue&type=script&lang=js"
export * from "./GalleryView.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./GalleryView.vue?vue&type=style&index=0&id=60b20898&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__